import { toast } from 'sonner';

// AI Recommendation function
export const getAIRecommendation = async (projectDescription, setWizardData, setAiLoading) => {
  setAiLoading(true);
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/wizard/detect-procurement-type`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        description: projectDescription
      })
    });
    
    if (!response.ok) {
      throw new Error('Failed to get AI recommendation');
    }
    
    const data = await response.json();
    const recommended = data.recommended_category.toLowerCase();
    
    setWizardData(prev => ({ 
      ...prev, 
      aiRecommendedType: recommended,
      aiConfidence: data.confidence,
      aiTopMatches: data.top_matches
    }));
    
    const matchInfo = data.top_matches && data.top_matches.length > 0 
      ? `Match: ${data.top_matches[0].name}` 
      : '';
    
    toast.success(`AI recommends: ${recommended.charAt(0).toUpperCase() + recommended.slice(1)} (${data.confidence} confidence)`, {
      description: matchInfo
    });
  } catch (error) {
    console.error('AI recommendation error:', error);
    toast.error('Failed to get AI recommendation');
  } finally {
    setAiLoading(false);
  }
};

// Download wizard summary as text file
export const downloadWizardSummary = (wizardData) => {
  try {
    const procType = wizardData.typeSelectionMethod === 'ai' 
      ? wizardData.aiRecommendedType 
      : wizardData.procurementType;
    
    let textContent = '='.repeat(80) + '\n';
    textContent += 'PROCUREMENT MODE SELECTION WIZARD - SUMMARY\n';
    textContent += '='.repeat(80) + '\n\n';
    
    textContent += 'PROJECT INFORMATION\n';
    textContent += '-'.repeat(80) + '\n';
    textContent += `Project Name: ${wizardData.projectName}\n`;
    if (wizardData.projectDescription) {
      textContent += `Description: ${wizardData.projectDescription}\n`;
    }
    textContent += `Entity Type: ${wizardData.entityType}\n`;
    textContent += `Procurement Type: ${procType}`;
    if (wizardData.typeSelectionMethod === 'ai') {
      textContent += ' (AI Recommended)';
    }
    textContent += '\n';
    if (procType === 'mixed' && wizardData.primaryPurpose) {
      textContent += `Primary Purpose: ${wizardData.primaryPurpose}\n`;
    }
    textContent += `Contract Value (ABC): ₱${parseFloat(wizardData.contractValue.replace(/,/g, '')).toLocaleString()}\n\n`;
    
    if (wizardData.specialConditionChoice) {
      textContent += 'SPECIAL CONDITIONS\n';
      textContent += '-'.repeat(80) + '\n';
      textContent += `Selected Condition: ${wizardData.specialConditionChoice === 'none' ? 'None' : wizardData.selectedScenario}\n`;
      if (wizardData.specialConditionChoice !== 'none') {
        textContent += `Details: ${wizardData.selectedConditionText}\n`;
      }
      textContent += '\n';
    }
    
    textContent += 'RECOMMENDED PROCUREMENT MODE\n';
    textContent += '-'.repeat(80) + '\n';
    if (wizardData.mainMode && wizardData.rankedModes.length > 0) {
      const selectedMode = wizardData.rankedModes.find(m => m.id === wizardData.mainMode);
      if (selectedMode) {
        textContent += `Mode: ${selectedMode.name}\n`;
        textContent += `Rank: #${selectedMode.rank}\n`;
        textContent += `Score: ${selectedMode.score}\n`;
        textContent += `Risk Level: ${selectedMode.riskLevel}\n`;
        textContent += `Scenario: ${selectedMode.scenario}\n`;
        textContent += `Condition: ${selectedMode.condition}\n`;
        textContent += `Verification Criteria: ${selectedMode.verificationCriteria}\n`;
      }
    }
    textContent += '\n';
    
    textContent += 'ALL RANKED MODES\n';
    textContent += '-'.repeat(80) + '\n';
    wizardData.rankedModes.forEach((mode, index) => {
      textContent += `${index + 1}. ${mode.name} (Score: ${mode.score}, Risk: ${mode.riskLevel})\n`;
      textContent += `   Scenario: ${mode.scenario}\n`;
      textContent += `   Condition: ${mode.condition}\n`;
      textContent += `   Verification: ${mode.verificationCriteria}\n\n`;
    });
    
    textContent += '='.repeat(80) + '\n';
    textContent += 'End of Summary\n';
    textContent += '='.repeat(80) + '\n';
    
    const blob = new Blob([textContent], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `procurement-mode-wizard-${wizardData.projectName.replace(/\s+/g, '-').toLowerCase()}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    toast.success('Wizard summary downloaded successfully');
  } catch (error) {
    console.error('Download error:', error);
    toast.error('Failed to download summary');
  }
};
